<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="800">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <span class="partido-title">Crear nuevo movimiento</span>
          <v-card-text>
            <form>
              <v-layout row wrap>
                <v-text-field v-model="description" label="Descripción" required @input="$v.description.$touch()"
                  prepend-icon="fa-comment" :error-messages="descriptionErrors" ></v-text-field>
                <div style="width: 100%;"></div>
                <v-autocomplete v-model="tipo" :items="tipos" label="Tipo de movimiento" itemText="description"
                  itemValue="id" prepend-icon="fa-list" light no-data-text="No hay datos disponibles" dense
                  :loading="loadingClubs" :error-messages="tipoErrors"></v-autocomplete>
                <v-flex v-if="!this.$store.getters.isClubRole" xs8 pr-2>
                  <SelectItems v-model="personas" :items="personasNames" itemText="nombre" itemValue="id"
                    label="Grupos a comunicar" prepend-icon="fa-user" :loading="loadingCriterion"></SelectItems>
                </v-flex>
                <v-flex v-if="!this.$store.getters.isClubRole" xs12>
                  <EmailCombobox ref="emails"></EmailCombobox>
                </v-flex>
              </v-layout>
              <AttachFile ref="fileInput" @upload="uploadFiles"></AttachFile>
              <v-btn color="blue-grey-lighten-4" @click="closeDialog">Volver</v-btn>
              <v-btn @click="openFileDirectory" color="primary" :disabled="saving">Agregar Adjunto</v-btn>
              <v-btn @click="uploadAllFiles" color="primary" :disabled="saving">Crear</v-btn>
            </form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import AttachFile from '../../../common/ui/AttachFile'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import EmailCombobox from '../../../common/ui/EmailCombobox'
import SelectItems from '../../../common/ui/SelectItems'
import { recipientsMixin } from '../../../mixins/recipientsMixin'

export default {
  mixins: [validationMixin, s3UploadMixin, recipientsMixin],

  validations: {
    description: { required },
    tipo: { required }
  },

  components: {
    EmailCombobox,
    SelectItems,
    AttachFile
  },

  props: {
    cardTitle: null,
    cardDetail: null,
    type: null,
    clubId: null,
    movimiento: null,
    expediente: null
  },

  data () {
    return {
      loading: false,
      saving: false,
      title: '',
      departamento: null,
      cuerpo: '',
      items: [],
      files: [],
      file: null,
      dialog: false,
      description: null,
      tipos: [],
      tipo: null
    }
  },
  computed: {
    descriptionErrors () {
      const errors = []
      if (!this.$v.description.$dirty) return errors
      !this.$v.description.required && errors.push('La descripción es requerida.')
      return errors
    },
    tipoErrors () {
      const errors = []
      if (!this.$v.tipo.$dirty) return errors
      !this.$v.tipo.required && errors.push('El tipo es requerido.')
      return errors
    }
    /* cuerpoErrors () {
      const errors = []
      if (!this.$v.cuerpo.$dirty) return errors
      !this.$v.cuerpo.required && errors.push('El cuerpo es requerido.')
      return errors
    } */
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saving = true
        const payload = {
          description: this.description,
          type: this.tipo,
          expediente: this.expediente.id,
          person_criteria: this.personas,
          emails: this.$refs.emails.getEmails(),
          assets: this.assets
        }
        this.axios
          .post('/expedientes/movimientos/create', payload)
          .then((response) => {
            this.$router.go()
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    },
    showDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },
    fetchTiposMovimiento () {
      this.loading = true
      this.axios
        .get('expedientes/tipos-movimientos')
        .then(response => {
          this.tipos = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    }
  },
  created () {
    this.loading = true
    this.fetchTiposMovimiento()
    this.clubes = this.clubId
  }
}
</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.4em;
  color: rgb(99, 95, 95);
  padding-top: 1.5em;
  margin-top: 2em;
}

.partido-title {
  color: lightslategray;
  font-size: 1.8em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
</style>
